import { render, staticRenderFns } from "./introduce-card.vue?vue&type=template&id=bfaa4960&scoped=true"
import script from "./introduce-card.vue?vue&type=script&lang=ts"
export * from "./introduce-card.vue?vue&type=script&lang=ts"
import style0 from "./introduce-card.vue?vue&type=style&index=0&id=bfaa4960&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfaa4960",
  null
  
)

export default component.exports